import { render, staticRenderFns } from "./ArticleOne.vue?vue&type=template&id=184da71a&scoped=true"
import script from "./ArticleOne.vue?vue&type=script&lang=js"
export * from "./ArticleOne.vue?vue&type=script&lang=js"
import style0 from "./ArticleOne.vue?vue&type=style&index=0&id=184da71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184da71a",
  null
  
)

export default component.exports